import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service Pages
const FireExtinguisherSalesPage = lazy(() => import('../pages/services/fire-extinguisher-sales/page'));
const FireExtinguisherRefillingPage = lazy(() => import('../pages/services/fire-extinguisher-refilling/page'));
const FireExtinguisherMaintenancePage = lazy(() => import('../pages/services/fire-extinguisher-maintenance/page'));
const FireEquipmentPage = lazy(() => import('../pages/services/fire-equipment/page'));
const ChimneyCleaningPage = lazy(() => import('../pages/services/chimney-cleaning/page'));
const HoodCleaningPage = lazy(() => import('../pages/services/hood-cleaning/page'));
const AutomaticHoodSuppressionPage = lazy(() => import('../pages/services/automatic-hood-suppression/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kurumsal',
    element: <AboutPage />,
  },
  {
    path: '/hizmetlerimiz',
    element: <ServicesPage />,
  },
  {
    path: '/hizmetlerimiz/yangin-tupu-satis',
    element: <FireExtinguisherSalesPage />,
  },
  {
    path: '/hizmetlerimiz/yangin-tupu-dolum',
    element: <FireExtinguisherRefillingPage />,
  },
  {
    path: '/hizmetlerimiz/yangin-tupu-bakim',
    element: <FireExtinguisherMaintenancePage />,
  },
  {
    path: '/hizmetlerimiz/yangin-sondurme-ekipmanlari',
    element: <FireEquipmentPage />,
  },
  {
    path: '/hizmetlerimiz/baca-temizligi',
    element: <ChimneyCleaningPage />,
  },
  {
    path: '/hizmetlerimiz/davlumbaz-temizligi',
    element: <HoodCleaningPage />,
  },
  {
    path: '/hizmetlerimiz/otomatik-davlumbaz-sondurme-sistemi',
    element: <AutomaticHoodSuppressionPage />,
  },
  {
    path: '/urunler',
    element: <ProductsPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/sss',
    element: <FAQPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
